import { useRef, useState, useCallback, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function O() {
    const { useLang, gtm } = useGlobal();
    const { t } = useLang('delta2max.detail');
    const [tabActive, setTabActive] = useState(0);
    const [swiper, setSwiper] = useState({ activeIndex: 0 });
    const domRef = useRef<HTMLDivElement>(null);
    const domChildRef = useRef<HTMLDivElement>(null);
    const arrLeftRef = useRef<Array<number>>([0]);
    const arrWidthRef = useRef<Array<number>>([]);
    const zoomRef = useRef<HTMLDivElement>(null);

    const initMove = useCallback((dom: any, arrHRef: number[], arrTRef: number[]) => {
        const child = dom.children;
        const len = child?.length || 0;
        for (let i = 0; i < len - 1; i++) {
            const item = child[i];
            arrHRef.push(item.clientWidth);

            if (i === len - 2) {
                break;
            }
            if (i !== 0) {
                arrTRef.push(arrTRef[i] + item.clientWidth + 40);
            } else {
                arrTRef.push(item.clientWidth + 40);
            }
        }
    }, []);

    const changeTab = useCallback((index: number) => {
        setTabActive(index);
        const ind = Number(index);
        (domChildRef.current as HTMLDivElement).style.cssText = `width: ${arrWidthRef.current[ind]}px; left: ${arrLeftRef.current[ind]}px`;
    }, []);

    const swiperChange = (e: any) => {
        onSwiperSlideTo(e.activeIndex);
    };

    const onSwiperSlideTo = (index: number) => {
        if (swiper && index !== tabActive) {
            swiper?.slideTo(index);
        }
        changeTab(index);
    };

    useEffect(() => {
        // 初始化tab1切换数据
        initMove(domRef.current, arrWidthRef.current, arrLeftRef.current);
        changeTab(0);
    }, []);

    return (
        <div
            ref={zoomRef}
            className={`d2x-detail-O ${css.d2xDetailO} GtmModuleData-section`}
            id="d2x-detail-O"
            data-section-id={'d2x-detail-O'}
            data-section-title={t('sec15_title1')}
        >
            <div className="text-box">
                <p className="desc">{t('sec15_desc1')}</p>
                <p className="title">{t('sec15_title1')}</p>
            </div>
            <Swiper
                className="video-content"
                pagination={false}
                slidesPerView={'auto'}
                initialSlide={0}
                effect="fade"
                spaceBetween={0}
                onSlideChange={swiperChange}
                onSwiper={(swiper: any) => setSwiper(swiper)}
            >
                <SwiperSlide>
                    <NextImage
                        webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/zh-1.webp')}
                        src={require('@publicLocal/delta2max/teaser/pc/eu/zh-1.jpg')}
                        alt={t('sec15_title1')}
                        aria-label={t('sec15_title1')}
                    />
                </SwiperSlide>
                <SwiperSlide>
                    <NextImage
                        webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/zh-2.webp')}
                        src={require('@publicLocal/delta2max/teaser/pc/eu/zh-2.jpg')}
                        alt={t('sec15_title1')}
                        aria-label={t('sec15_title1')}
                    />
                </SwiperSlide>
                <SwiperSlide>
                    <NextImage
                        webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/zh-3.webp')}
                        src={require('@publicLocal/delta2max/teaser/pc/eu/zh-3.jpg')}
                        alt={t('sec15_title1')}
                        aria-label={t('sec15_title1')}
                    />
                </SwiperSlide>
                <SwiperSlide>
                    <NextImage
                        webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/zh-4.webp')}
                        src={require('@publicLocal/delta2max/teaser/pc/eu/zh-4.jpg')}
                        alt={t('sec15_title1')}
                        aria-label={t('sec15_title1')}
                    />
                </SwiperSlide>
            </Swiper>
            <div ref={domRef} className={`tab active-0${tabActive}`}>
                <button
                    onClick={() => {
                        onSwiperSlideTo(0);
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'tab_click',
                            button_name: t('sec15_tab1'),
                            list_name: t('sec15_title1'),
                        });
                    }}
                >
                    {t('sec15_tab1')}
                </button>
                <button
                    onClick={() => {
                        onSwiperSlideTo(1);
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'tab_click',
                            button_name: t('sec15_tab2'),
                            list_name: t('sec15_title1'),
                        });
                    }}
                >
                    {t('sec15_tab2')}
                </button>
                <button
                    onClick={() => {
                        onSwiperSlideTo(2);
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'tab_click',
                            button_name: t('sec15_tab3'),
                            list_name: t('sec15_title1'),
                        });
                    }}
                >
                    {t('sec15_tab3')}
                </button>
                <button
                    onClick={() => {
                        onSwiperSlideTo(3);
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'tab_click',
                            button_name: t('sec15_tab4'),
                            list_name: t('sec15_title1'),
                        });
                    }}
                >
                    {t('sec15_tab4')}
                </button>
                <span ref={domChildRef}></span>
            </div>
            <div className="text-box text-box2">
                <p className="title">{t(`sec15_subTitle${tabActive + 1}`)}</p>
                <p className="desc">{t(`sec15_subDesc${tabActive + 1}`)}</p>
            </div>
        </div>
    );
}
